<!-- 接入指南 -->
<template>
    <div class="content">
        <el-backtop ></el-backtop>
        <ul>
            <li>
                <h2 class="title">艾联客PC端开放平台授权申请指引</h2>
            </li>
        </ul>

        <ul>
          <li>
            <div style="width: 100%">
              <table style="width: 100%">
                <tr>
                  <td><h2>登录艾联客系统，进入【项目管理】-【软件授权】,选择【创建软件授权】</h2></td>
                </tr>
                <tr>
                  <td><a href="#"><img src="/static/img/0606-1.png" style="width: 100%"/></a></td>
                </tr>
              </table>
            </div>
            <div style="width: 100%">
              <table style="width: 100%">
                <tr>
                  <td><h2>填写软件授权相关信息</h2>
                    申请类型】选择开放平台接口授权
                    <br>
                    【开发环境】有测试环境和正式环境，根据项目实际需求进行选择
                    <br>
                    【软件类型】根据项目使用的出入口系统进行选择
                    <br>
                    【项目名称】、【销售负责人】、【车场编码】、【项目合作模式】、【合同编号】、【车场运营商名称】根据具体项目进行填写
                  </td>

                </tr>
                <tr>
                  <td><a href="#"><img src="/static/img/0606-2.png" style="width: 100%"/></a></td>
                </tr>
              </table>
              <div style="width: 100%">
                <table style="width: 100%">
                  <tr>
                    <td><h2>填写好软件授权基础信息后，点击【点击填写开放平台申请资料】后，填写开放平台接口的相关信息</h2></td>
                  </tr>
                  <tr>
                    <td><a href="#"><img src="/static/img/0606-3.png" style="width: 100%"/></a></td>
                  </tr>
                </table>
              </div>
              <div style="width: 100%">
                <table style="width: 100%">
                  <tr>
                    <td><h2>填写【授权商在线申请】相关信息</h2>
                      授权商名称】填写负责对接开发的开发方名称（如已有授权商，则填写已有授权商名称） <br>
                      【联系人】、【联系电话】填写开发负责人或项目负责人的信息<br>
                      【登录账号】、【登录密码】、【确认密码】自定义填写，用于后续登录查看接口授权情况。其中【登录密码】、【确认密码】内容需一致
                    </td>
                  </tr>
                  <tr>
                    <td><a href="#"><img src="/static/img/0606-4.png" style="width: 100%"/></a></td>
                  </tr>
                </table>
              </div>
              <div style="width: 100%">
                <table style="width: 100%">
                  <tr>
                    <td><h2>基础信息填写好后，点击【授权配置】-【选择权限】，进入授权配置页面</h2>
                      在【功能模块（接口）授权】勾选所需接口，并在【车场授权】中选择项目对应的车场<br>
                      注：如果【功能模块（接口）授权】中没有项目所需接口，可以进入【接口授权】中进行搜索
                    </td>
                  </tr>
                  <tr>
                    <td><a href="#"><img src="/static/img/0606-5.png" style="width: 100%"/></a></td>
                  </tr>
                  <tr>
                    <td><a href="#"><img src="/static/img/0606-6.png" style="width: 100%"/></a></td>
                  </tr>
                  <tr>
                    <td><a href="#"><img src="/static/img/0606-7.png" style="width: 100%"/></a></td>
                  </tr>
                  <tr>
                    <td><a href="#"><img src="/static/img/0606-8.png" style="width: 100%"/></a></td>
                  </tr>
                </table>
              </div>
              <div style="width: 100%">
                <table style="width: 100%">
                  <tr>
                    <td><h2>配置好【授权商在线申请】中所有信息后，点击提交</h2></td>
                  </tr>
                  <tr>
                    <td><a href="#"><img src="/static/img/0606-9.png" style="width: 100%"/></a></td>
                  </tr>
                </table>
              </div>
              <div style="width: 100%">
                <table style="width: 100%">
                  <tr>
                    <td>
                      <h2>【授权商在线申请】提交成功后，需返回艾联客-【创建软件授权】页面，再次提交，提交完成后才算是将整个申请提交完成</h2>
                      注：如果只是提交【授权商在线申请】信息，申请流程是无法流转下去的
                    </td>
                  </tr>
                  <tr>
                    <td><a href="#"><img src="/static/img/0606-10.png" style="width: 100%"/></a></td>
                  </tr>
                </table>
              </div>
              <div style="width: 100%">
                <table style="width: 100%">
                  <tr>
                    <td>
                      <h2>申请流程提交完成后，可以在【艾联客】-【项目管理】-【软件授权】中看到对应的明细。点击【进度】可查看申请进度</h2>
                      注：如果在【艾联客】-【项目管理】-【软件授权】中无法找到相关明细，则大概率没有提交成功，需重新申请提交或联系客服同事协助处理
                    </td>
                  </tr>
                  <tr>
                    <td><a href="#"><img src="/static/img/0606-11.png" style="width: 100%"/></a></td>
                  </tr>
                  <tr>
                    <td><a href="#"><img src="/static/img/0606-12.png" style="width: 100%"/></a></td>
                  </tr>
                </table>
              </div>
            </div>
          </li>
        </ul>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    name: '',
    props: {
        'Pdatas': {
            type: Object,
        }
    },
    data() {
        return {
            respTable: [
                { info1: 'status', info2: '是', info3: 'int', info4: '状态码',info5:'1业务成功,2业务失败,3系统异常,4签名错误,5key错误,6未授权,7请求参数不完整' },
                { info1: 'resultCode', info2: '是', info3: 'int', info4: '业务码',info5:'只有状态码为2时才生效，状态码不为2时业务结果为0;901-系统发生异常,902-远程服务器未响应,903-运营商不存在,904-停车场不存在,905-未找到在场车辆,906-账单不存在,907-账单已同步,908-其它错误,909-请求参数错误,910-找不到授权商下面的停车场,911-无权限操作该停车场,912-查费已超时，请重新查费,1801-找不到指定车辆'},
                { info1: 'message', info2: '是', info3: 'String', info4: '结果描述' },
                { info1: 'data', info2: '是', info3: 'JSONObject', info4: '返回数据' }
            ],
            othersData: [],
            explainWidth: 200,
            alarmGuideUrl: 'Api/alarmGuide#0',
            customHelp: ''
        }
    },
    computed: {
      ...mapState(["url"])
    },
    created() {
        if (this.$root.customConfig.help && Object.keys(this.$root.customConfig.help).length > 0) {
            this.customHelp = this.$root.customConfig.help;
        }
        this.initCommonUrls()
    },
    watch: {
      '$route'(to, from) {
        this.initCommonUrls()
      }
    },
    methods: {
      initCommonUrls() {
        let url = window.location.href;
        this.alarmGuideUrl = '/Api/alarmGuide#0'
      },
    },

}
</script>

<style lang="less" scoped>
.content {
    // font-family: "Helvetica Neue", "Hiragino Sans GB", "Microsoft YaHei", '黑体', Arial, sans-serif;
    font-size: 14px; // background-image: url(../../assets/img/back.png);
    line-height: 1.6;
    color: #1f2d3d;
    h3 {
        margin: 0;
        padding: 0px 0 20px 0; // font-family: HiraginoSansGB-W3;
        font-size: 18px;
        color: #111B29;
        letter-spacing: 0
    }
    a {
        font-size: 13px;
    }
    ul {
        padding: 5px 10px;
        li {
            text-align: left;
        }
        a.el-link {
            text-decoration: none;
        }
    }
    .retract {
        padding-left: 15px;
    }
    pre {
        background-color: #f6f6f6;
        font-size: 12px;
    }
}

.subName {
    padding: 15px 0 10px 15px;
    max-width: 90%;
    min-width: 80%;
    color: #333;
}

table {
    display: table;
    max-width: 90%;
    min-width: 80%;
    border-collapse: collapse;
    border-spacing: 0;
    overflow: auto;
    border-bottom: 1px solid #e7e7eb;
}

thead tr:first-child {
    background-color: #f6f8f9;
}

table tr:first-child {
    border: none;
}

table tr {
    border-top: 1px solid #e7e7eb;
}

table th {
    font-weight: 400;
    color: #8d8d8d;
    text-align: left;
    height: 40px;
    padding: 6px 12px;
    white-space: nowrap;
    border: none;
}

table td {
    // height: 35px;
    padding: 15px 12px;
    text-align: justify;
}

.red-text {
  color: red; /* 使用 CSS 颜色名 */
}

/* 或者使用十六进制颜色代码 */
.red-text {
  color: #FF0000;
}
</style>



// WEBPACK FOOTER //
// src/components/Doc/apply.vue